import React from "react";
import i18n from "@microdoing/shared/i18n";
import theme from "app/Theme/Theme";
import { Platform, Text, TextInput, View } from "react-native";
import normalize from "app/utils/normalize";
import { MainText } from "app/components/common";

const MIN_HEIGHT = 60;

const CommentBox = ({
  onChangeText,
  placeholder,
  autoFocus = false,
  value,
  maxHeight = null,
  hasExplanation = false,
  testID = undefined,
  ...props
}) => {
  return (
    <>
      {hasExplanation && (
        <>
          {!!value ? (
            <MainText variant="l2-regular" color="neutral.600">
              {i18n.t("debrief-explanation")}
            </MainText>
          ) : (
            <Text style={[styles.explanation, styles.explanationSelected]}>
              {i18n.t("find-your-debrief")}
            </Text>
          )}
        </>
      )}
      <View
        style={[styles.inputContainer, props.style, maxHeight && { maxHeight }]}
      >
        <TextInput
          testID={testID}
          hitSlop={{ top: 10, bottom: 30, left: 10, right: 20 }}
          {...props}
          placeholder={placeholder}
          multiline
          onChangeText={onChangeText}
          styleTextInput={{ ...styles.textInput }}
          style={{ ...styles.textInput, maxHeight }}
          autoFocus={autoFocus}
          value={value}
          enablesReturnKeyAutomatically
          underlineColorAndroid="transparent"
        />
      </View>
    </>
  );
};

const styles = {
  inputContainer: {
    maxWidth: "100%",
    borderRadius: 8,
    borderWidth: 1,
    borderColor: theme.colors["neutral.100"],
    minHeight: normalize(80),
    padding: theme.spacing.sm,
    backgroundColor: theme.colors["neutral.white"],
    overflow: "hidden",
  },
  textInput: {
    color: theme.colors["neutral.900"],
    width: "100%",
    textAlign: "left",
    alignItems: "center",
    justifyContent: "center",
    minHeight: Platform.OS === "web" ? 150 : MIN_HEIGHT,
    fontSize: 16,
    outlineWidth: 0,
    padding: 10,
  },
};

export default CommentBox;
